import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';

// Redux
import { connect } from 'react-redux';

// Style
import { Grid, Row, Col } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Dashboard.css';
import bt from '../../components/commonStyle.css';

// Components
import UnreadMessages from './UnreadMessages';
import DashboardMenu from './DashboardMenu';
import DashBoardSideMenu from './DashBoardSideMenu';
import DashboardSideNav from './DashboardSideNav';

// GraphQL
import UnreadThreadsQuery from './getUnreadThreads.graphql';
import { withQuery } from '../../hoc/withGraphql';

// Locale
import messages from '../../locale/messages';

// Images
import FondoBanner       from '/public/SiteImages/fondo-montañas+casa.svg';
import PersonajeSaludando from '/public/SiteImages/personaje-saludando-2.svg';
import WavingHand        from '/public/SiteIcons/wavingHand.png';
import ChevronRight      from '/public/SiteIcons/chevron-right.svg';

const Dashboard = (props) => {
  const { account: { userId, picture, firstName }, siteName, allUnreadThreads } = props;
  const { loading, getDashboardUnreadThreads } = allUnreadThreads || {};
  const { formatMessage } = useIntl();

  const newMessages = !loading && getDashboardUnreadThreads ? getDashboardUnreadThreads.length : 0;
  const messageCount = `${formatMessage(messages.messages)} (${newMessages})`;

  return (
    <Grid fluid className={cx(s.pageContainer, 'ViewProfile')}>
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className={'dashBoardGrid'}>

            {/* ── COLUMNA IZQUIERDA: menú lateral de navegación ── */}
            <div className={s.leftColumn}>
              <DashboardSideNav />
            </div>

            {/* ── COLUMNA DERECHA: contenido principal ── */}
            <div className={s.rightColumn}>

              {/* 1. Banner de saludo */}
              <div
                className={s.heroBanner}
                style={{ backgroundImage: `url(${FondoBanner})` }}
              >
                <div className={s.bannerContent}>
                  <img src={PersonajeSaludando} alt="Personaje saludando" className={s.bannerCharacter} />
                  <div className={s.bannerText}>
                    <h2 className={s.bannerGreeting}>
                      {`¡Hola, ${firstName || 'Alex'}!`}
                    </h2>
                    <p className={s.bannerSubtitle}>Qué bueno tenerte de vuelta.</p>
                    <p className={s.bannerSubtitle}>Aquí puedes ver tus reservas, mensajes y más.</p>
                  </div>
                </div>
              </div>

              {/* 2. Sub-grid debajo del banner:
                       izquierda = foto de perfil + info verificada
                       derecha   = accesos rápidos + mensajes          */}
              <div className={s.belowBannerGrid}>

                {/* Columna de perfil e info verificada */}
                <div className={s.profileColumn}>
                  <DashBoardSideMenu data={props.account} />
                </div>

                {/* Columna de accesos rápidos y mensajes */}
                <div className={s.mainColumn}>
                  {/* Sección de nota informativa */}
                  <div className={s.dashboardNoteCard}>
                    <div className={s.dashboardNoteIconWrap}>
                      <img src={WavingHand} alt="" className={s.dashboardNoteIcon} />
                    </div>
                    <div className={s.dashboardNoteContent}>
                      <h4 className={s.dashboardNoteTitle}>
                        {formatMessage(messages.sayHelloTo)} {firstName && <> {firstName}</>}
                      </h4>
                      <p className={s.dashboardNoteText}>
                        <span className={s.dashboardNoteGreetingBold}>
                          {`¡${formatMessage(messages.sayHelloTo)} ${firstName || ''}! `}
                        </span>
                        <FormattedMessage {...messages.dashBoardInfo} />{' '}
                        <FormattedMessage {...messages.dashBoardInfo1} />
                      </p>
                    </div>
                  </div>

                  {/* Tarjetas Mis reservas · Favoritos · Mensajes */}
                  <DashboardMenu />

                  {/* Bandeja de mensajes */}
                  <div className={s.messagesSection}>
                    <div className={s.messagesSectionHeader}>
                      <h4 className={s.messageCountText}>{messageCount}</h4>
                      <a href="/inbox" className={s.viewAllLink}>
                        Ver todos <img src={ChevronRight} alt="" className={s.viewAllChevron} />
                      </a>
                    </div>
                    <UnreadMessages
                      userId={userId}
                      loading={loading}
                      getUnreadThreads={getDashboardUnreadThreads}
                    />
                  </div>
                </div>

              </div>{/* /belowBannerGrid */}
            </div>{/* /rightColumn */}

          </div>{/* /dashBoardGrid */}
        </Col>
      </Row>
    </Grid>
  );
};

Dashboard.propTypes = {
  account: PropTypes.shape({
    userId: PropTypes.string.isRequired,
    picture: PropTypes.string,
    firstName: PropTypes.string,
  }).isRequired,
  allUnreadThreads: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    getDashboardUnreadThreads: PropTypes.array,
  }),
  siteName: PropTypes.string.isRequired,
};

Dashboard.defaultProps = {
  allUnreadThreads: {
    loading: true,
    getDashboardUnreadThreads: [],
  },
  account: {
    userId: null,
    picture: null,
    firstName: '',
  },
};

const mapState = (state) => ({
  account: state.account.data,
  siteName: state.siteSettings.data.siteName,
});

export default compose(
  withStyles(s, bt),
  connect(mapState),
  withQuery(UnreadThreadsQuery, {
    name: 'allUnreadThreads',
    options: {
      ssr: false,
      fetchPolicy: 'network-only',
    },
  })
)(Dashboard);